import classNames from "classnames";
import React, { Component } from "react";
import Logo from "./Logo";

class LogoLoader extends Component {
  render() {
    const { loading } = this.props;

    return (
      <Logo
        fill={this.props.fill}
        className={classNames(loading && "loading", this.props.className)}
      />
    );
  }
}

export default LogoLoader;



// WEBPACK FOOTER //
// ./src/appBar/LogoLoader.js